// Date utility functions for Sri Lanka timezone handling

/**
 * Get current date in Sri Lanka timezone
 * Sri Lanka Standard Time (SLST) is UTC+5:30
 */
export const getSriLankaDate = () => {
  const now = new Date();
  // Convert to Sri Lanka timezone (UTC+5:30)
  const sriLankaTime = new Date(now.getTime() + (5.5 * 60 * 60 * 1000));
  return sriLankaTime;
};

/**
 * Get current date string in YYYY-MM-DD format for Sri Lanka timezone
 */
export const getSriLankaDateString = () => {
  const sriLankaDate = getSriLankaDate();
  return sriLankaDate.toISOString().split('T')[0];
};

/**
 * Get current time in Sri Lanka timezone
 */
export const getSriLankaTime = () => {
  const sriLankaDate = getSriLankaDate();
  return sriLankaDate.toTimeString().split(' ')[0].substring(0, 5); // HH:MM format
};

/**
 * Get current date and time in Sri Lanka timezone
 */
export const getSriLankaDateTime = () => {
  const sriLankaDate = getSriLankaDate();
  return {
    date: sriLankaDate.toISOString().split('T')[0],
    time: sriLankaDate.toTimeString().split(' ')[0].substring(0, 5),
    datetime: sriLankaDate.toISOString(),
    formatted: sriLankaDate.toLocaleString('en-US', {
      timeZone: 'Asia/Colombo',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    })
  };
};

/**
 * Convert a date to Sri Lanka timezone
 * @param {Date|string} date - Date to convert
 */
export const convertToSriLankaTime = (date) => {
  const inputDate = new Date(date);
  // Convert to Sri Lanka timezone (UTC+5:30)
  const sriLankaTime = new Date(inputDate.getTime() + (5.5 * 60 * 60 * 1000));
  return sriLankaTime;
};

/**
 * Get Sri Lanka timezone offset in hours
 */
export const getSriLankaTimezoneOffset = () => {
  return 5.5; // UTC+5:30
};

/**
 * Format date for display in Sri Lanka timezone
 * @param {Date|string} date - Date to format
 */
export const formatSriLankaDate = (date) => {
  const sriLankaDate = convertToSriLankaTime(date);
  return sriLankaDate.toLocaleDateString('en-US', {
    timeZone: 'Asia/Colombo',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Format time for display in Sri Lanka timezone
 * @param {Date|string} date - Date to format
 */
export const formatSriLankaTime = (date) => {
  const sriLankaDate = convertToSriLankaTime(date);
  return sriLankaDate.toLocaleTimeString('en-US', {
    timeZone: 'Asia/Colombo',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
};

/**
 * Get minimum selectable date (today in Sri Lanka timezone)
 */
export const getMinSelectableDate = () => {
  return getSriLankaDateString();
};

/**
 * Get maximum selectable date (30 days from today in Sri Lanka timezone)
 */
export const getMaxSelectableDate = () => {
  const today = getSriLankaDate();
  const maxDate = new Date(today.getTime() + (30 * 24 * 60 * 60 * 1000)); // 30 days from today
  return maxDate.toISOString().split('T')[0];
};
